import Vue from 'vue';
import helpers from './mixins/helpers'
import Vuex from 'vuex';
import timer from '../components/timer/timer'
Vue.use(Vuex);
import { store } from './store';

if(document.getElementById('lection')) {
    $(document).ready(function() {
        $("body").keydown(function(e) {
            if(e.keyCode == 37) { // left
                showLection.goToPrevLection();
            }
            else if(e.keyCode == 39) { // right
                showLection.goToNextLection();
            }
        });
    });
    var showLection = new Vue({
        mixins: [helpers],
        el: '#lection',
        store,
        data: {
            rating: 0,
            ratingMessage: null,
            nmoStatus:nmoStatus,
            nmoProgress:nmoProgress,
            messages:null,
            message:null,
            nextLection:nextLectionId,
            prevLection:prevLectionId,
            showBanner: true,
            os: store.state.os,
            specList: specList,
            specVisible: 5,
            timerTest: {
                ended_at: ended_at,
                timeCurrent: null
            },
            lection: lection


        },
        computed: {
            nextLectionUrl (){
              if(this.nextLection !== null){
                  return '/lections/'+this.nextLection;
              } else{
                  return false;
              }

          },
            prevLectionUrl (){
              if(this.prevLection !== null){

                  return '/lections/'+this.prevLection;

              } else{

                  return false;

              }
          },
            statusLecture () {
                if (this.nmoProgress.lection.status === true && this.nmoProgress.lection.show === true) {
                    return 'progress-nmo__step_success'
                }
                else if(this.nmoProgress.lection.status === false && this.nmoProgress.lection.show === true) {
                    return 'progress-nmo__step_error'
                }
                else if(this.nmoProgress.lection.show === true && this.nmoProgress.lection.status === null)  {
                    return 'progress-nmo__step_current'
                }
            },
            statusTest () {
                if (this.nmoProgress.lection.status !== null && this.nmoProgress.test.show === true) {
                    if (this.nmoProgress.test.status === true && this.nmoProgress.test.show === true) {
                        return 'progress-nmo__step_success'
                    }
                    else if(this.nmoProgress.test.status === false && this.nmoProgress.test.show === true) {
                        return 'progress-nmo__step_error'
                    }
                    else if(this.nmoProgress.test.show === true && this.nmoProgress.test.status === null)  {
                        return 'progress-nmo__step_current'
                    }
                    return 'progress-nmo__step_current'
                }

            },
            statusNmo () {
                if (this.nmoProgress.test.status !== null && this.nmoProgress.nmo.show === true) {
                    if (this.nmoProgress.nmo.status === true && this.nmoProgress.nmo.show === true) {
                        return 'progress-nmo__step_success'
                    }
                    else if(this.nmoProgress.nmo.status === false && this.nmoProgress.nmo.show === true) {
                        return 'progress-nmo__step_error'
                    }
                    else if(this.nmoProgress.nmo.show === true && this.nmoProgress.nmo.status === null)  {
                        return 'progress-nmo__step_current'
                    }
                    return 'progress-nmo__step_current'
                }

            }
        },
        methods: {
            goToNextLection (){
                if(this.nextLectionUrl){
                    document.location.href = this.nextLectionUrl;
                }

            },
            goToPrevLection (){
               if(this.prevLectionUrl){
                   document.location.href = this.prevLectionUrl;
               }
            },
            setRating () {
                var self = this;

                if (this.rating > 0) {

                    var $btn = $("#sendRating");

                    $btn.attr('disabled', true);

                    try {
                        $.ajax({
                            url: '/lections/default/set-rating/' + lection_id,
                            dataType: "json",
                            method: 'POST',
                            data: {
                                _csrf: self.getCsrf(),
                                vote: self.rating,
                                message: self.ratingMessage
                            },
                            success: function (data) {

                                $('.modal-2 ').modal('hide');
                                $btn.attr('disabled', false);
                            },
                            fail: function () {

                                throw new Error('Ошибка получении данных');

                            }
                        });

                    } catch (e) {

                        //Отправить данные об ошибке в систему логов

                        console.error(e);

                    }

                }


            },
            getMessages (){
                var self = this;

                $.ajax({
                    url:'/lections/get-lector-messages/'+lection_id,
                    type: "GET",
                    success:function (data){
                        self.messages = data;
                    }
                });
            },
            deleteMessage (){
                var self = this;

                $.ajax({
                    url:'/lections/default/delete-lector-message',
                    type: "POST",
                    data:{
                        _csrf: self.getCsrf(),
                        id:id
                    },
                    success:function (data){
                       self.getMessages();
                    }
                });
            },
            sendMessage (){
                var self = this;

                if(self.message){
                    $.ajax({
                        url:'/lections/send-lector-message/'+lection_id,
                        type: "POST",
                        data: {
                            _csrf: self.getCsrf(),
                            message:self.message
                        },
                        success:function (){
                            self.message = null;
                            self.getMessages();
                        }
                    });
                }

            },
            bannerLocalStorage (){
                localStorage.setItem('bannerHidden', 1)
            },
            moreSpec (){
                if (this.specVisible === 5){
                    this.specVisible = 1000
                }
                else if (this.specVisible !== 5) {
                    this.specVisible = 5
                }

            },
            getDelayTime (time) {
                // эта функция скопирована уже 4 раза =(
                let currentDate = Date.now();
                let startDay = new Date(time * 1000 - currentDate);

                let returnStr = '';

                if(startDay.getUTCHours()  > 0) {
                    returnStr += startDay.getUTCHours() + ' ч. ';
                }

                if(startDay.getMinutes() > 0){
                    returnStr +=  startDay.getMinutes()  + ' мин. ';
                }

                return returnStr;
            },
            openModal () {
                $('.pro-subscription-modal').modal('show')
            }
        },
        created () {
            if (localStorage.getItem('bannerHidden', 1)) {
                this.showBanner = false;
            }
            else {
                this.showBanner = true;
            }
        },
        components: {
            timer
        }

    });
    $('#lector-message-modal').on('show.bs.modal', function () {
            showLection.getMessages();
    });
}

